import React from 'react';
import WordMark from './WordMark';

/**
 * Logo — thin wrapper over WordMark for backward compatibility.
 * All 20 pages that import Logo now render the text wordmark automatically.
 * textColor="text-white" → inverted (white text)
 */
const Logo = ({ size = 'md', showText = true, className = '', textColor = '' }) => {
  const inverted = textColor === 'text-white' || textColor === '#ffffff' || textColor.includes('white');
  return <WordMark size={size} inverted={inverted} className={className} />;
};

// Kept for backward compat — previously called after logo upload
export const clearLogoCache = () => {};

export default Logo;
